import {Anchor, Fieldset, TextInput} from '@mantine/core'
import type {FormValues} from './FormValues.ts'
import type {UseFormReturnType} from '@mantine/form'

type Props = {
  form: UseFormReturnType<FormValues>
  disabledApiKey: boolean
  disabled: boolean
}

export const FormFields = ({form, disabledApiKey, disabled: containerDisabled}: Props) => {
  const disabled = containerDisabled

  return (
    <>
      <Fieldset legend={'General'}>
        <TextInput
          label={'Name'}
          key={form.key('name')}
          {...form.getInputProps('name')}
          style={{minWidth: 325}}
          required
          disabled={disabled}
        />
      </Fieldset>
      <Fieldset legend={'GitHub'}>
        <TextInput
          label={'Api Token'}
          description={
            <Anchor href={'https://github.com/settings/tokens'} size={'xs'} target={'_blank'}>
              Manage GitHub API Tokens
            </Anchor>
          }
          placeholder={'ghp...'}
          key={form.key('apiKey')}
          {...form.getInputProps('apiKey')}
          style={{minWidth: 325}}
          required
          disabled={disabled || disabledApiKey}
        />
      </Fieldset>
    </>
  )
}
